import { connect } from 'react-redux';
import { login } from 'core/slices/users';
import Login from '../../../components/login/Login';

export default connect(
  state => ({
    isAuthenticated: state.users.isAuthenticated,
    authLoading: state.users.authLoading,
    authError: state.users.authError
  }),
  { login }
)(Login);
